export const satisfiedEmotions = [
  "affectionate",
  "compassionate",
  "friendly",
  "loving",
  "open hearted",
  "sympathetic",
  "tender",
  "warm",
  "engaged",
  "alert",
  "curious",
  "engrossed",
  "enchanted",
  "entranced",
  "fascinated",
  "interested",
  "intrigued",
  "involved",
  "spellbound",
  "stimulated",
  "hopeful",
  "expectant",
  "encouraged",
  "optimistic",
  "confident",
  "empowered",
  "open",
  "proud",
  "safe",
  "secure",
  "excited",
  "animated",
  "ardent",
  "aroused",
  "astonished",
  "dazzled",
  "eager",
  "energetic",
  "enthusiastic",
  "giddy",
  "invigorated",
  "lively",
  "passionate",
  "surprised",
  "vibrant",
  "grateful",
  "appreciative",
  "moved",
  "thankful",
  "touched",
  "inspired",
  "amazed",
  "awed",
  "wonder",
  "joyful",
  "amused",
  "delighted",
  "glad",
  "happy",
  "jubilant",
  "pleased",
  "tickled",
  "exhilarated",
  "blissful",
  "ecstatic",
  "elated",
  "enthralled",
  "exuberant",
  "radiant",
  "rapturous",
  "thrilled",
  "peaceful",
  "calm",
  "clear headed",
  "comfortable",
  "centered",
  "content",
  "equanimous",
  "fulfilled",
  "mellow",
  "quiet",
  "relaxed",
  "relieved",
  "satisfied",
  "serene",
  "still",
  "tranquil",
  "trusting",
  "refreshed",
  "enlivened",
  "rejuvenated",
  "renewed",
  "rested",
  "restored",
  "revived",
];

export const unsatisfiedEmotions = [
  "afraid",
  "apprehensive",
  "dread",
  "foreboding",
  "frightened",
  "mistrustful",
  "panicked",
  "petrified",
  "scared",
  "suspicious",
  "terrified",
  "wary",
  "worried",
  "annoyed",
  "aggravated",
  "dismayed",
  "disgruntled",
  "displeased",
  "exasperated",
  "frustrated",
  "impatient",
  "irritated",
  "irked",
  "angry",
  "enraged",
  "furious",
  "incensed",
  "indignant",
  "irate",
  "livid",
  "outraged",
  "resentful",
  "aversive",
  "animosity",
  "appalled",
  "contempt",
  "disgusted",
  "dislike",
  "hate",
  "horrified",
  "hostile",
  "repulsed",
  "confused",
  "ambivalent",
  "baffled",
  "bewildered",
  "dazed",
  "hesitant",
  "lost",
  "mystified",
  "perplexed",
  "puzzled",
  "torn",
  "disconnected",
  "alienated",
  "aloof",
  "apathetic",
  "bored",
  "cold",
  "detached",
  "distant",
  "distracted",
  "indifferent",
  "numb",
  "removed",
  "uninterested",
  "withdrawn",
  "disquiet",
  "agitated",
  "alarmed",
  "discombobulated",
  "disconcerted",
  "disturbed",
  "perturbed",
  "rattled",
  "restless",
  "shocked",
  "startled",
  "surprised",
  "troubled",
  "turbulent",
  "turmoil",
  "uncomfortable",
  "uneasy",
  "unnerved",
  "unsettled",
  "upset",
  "embarassed",
  "ashamed",
  "chagrined",
  "flustered",
  "guilty",
  "mortified",
  "self-conscious",
  "fatigued",
  "beat",
  "burnt out",
  "depleted",
  "exhausted",
  "lethargic",
  "listless",
  "sleepy",
  "tired",
  "weary",
  "worn out",
  "pained",
  "agony",
  "anguished",
  "bereaved",
  "devastated",
  "grief",
  "heartbroken",
  "hurt",
  "lonely",
  "miserable",
  "regretful",
  "remorseful",
  "sad",
  "depressed",
  "dejected",
  "despair",
  "despondent",
  "disappointed",
  "discouraged",
  "disheartened",
  "forlorn",
  "gloomy",
  "heavy hearted",
  "hopeless",
  "melancholy",
  "unhappy",
  "wretched",
  "tense",
  "anxious",
  "cranky",
  "distressed",
  "distraught",
  "edgy",
  "fidgety",
  "frazzled",
  "irritable",
  "jittery",
  "nervous",
  "overwhelmed",
  "stressed out",
  "vulnerable",
  "fragile",
  "guarded",
  "helpless",
  "insecure",
  "leery",
  "reserved",
  "sensitive",
  "shaky",
  "yearning",
  "envious",
  "jealous",
  "longing",
  "nostalgic",
  "pining",
  "wistful",
];

export const mainSatisfiedEmotions = [
  "affectionate",
  "engaged",
  "hopeful",
  "confident",
  "excited",
  "grateful",
  "inspired",
  "joyful",
  "exhilirated",
  "peaceful",
  "refreshed",
];

export const mainUnsatisfiedEmotions = [
  "afraid",
  "annoyed",
  "angry",
  "aversive",
  "confused",
  "disconnected",
  "disquiet",
  "embarrassed",
  "fatigue",
  "pain",
  "sad",
  "tense",
  "vulnerable",
  "yearning",
];
